import React from 'react'
import { Row, Col } from 'reactstrap'
import RedirectButton from 'components/atoms/redirect-button'
import PropTypes from 'prop-types'

const propTypes = {
  promos: PropTypes.array
}

const defaultProps = {
  promos: []
}

const CmsHomepageSectionPromos = ({ promos }) => {
  //move out highlighted promo section & content
  const highlightedPromoSection = promos[0]
  // const highlightedPromoContent = promoContents[0]

  //move out sub promo section & content
  const subPromoSections = promos.slice(1,10)
  // const subPromoContents = promoContents.slice(1,10)

  //index for wider sub promo's image (index start from 0)
  const widerPromoPositions = [ 1, 3, 8 ]

  //set sub promo's image width
  const promoWidth = (index) => {
    const isWider = widerPromoPositions.find((element) => element === index)
    const colSize = isWider ? '6' : '3'
    return colSize
  }

  return (
    <>
      { /*highlighted promo, full width*/ }
      <div className='d-flex flex-wrap mb-4 mt-5'>
        <div className="p-0 col-12 col-md-7 col-xl-7">
          <img
            src={ highlightedPromoSection.image_url }
            width='100%'
            loading='lazy'
            alt={ highlightedPromoSection.alt_text }
          />
        </div>
        <div className="col-12 col-md-5 col-xl-5">
          <h1>{ highlightedPromoSection.title_text }</h1>
          <h5>{ highlightedPromoSection.caption_text }</h5>
          <RedirectButton
            text={ `Edit ${highlightedPromoSection.name}` }
            path={ `sections/${highlightedPromoSection.id}` }
            color='primary'
            className="float-right mt-1"
            size='sm'
          />
        </div>
      </div>

      { /*sub promo with 1 wider image each row*/ }
      <Row>
        {
          subPromoSections.map((promo, index) => (
            <Col lg={ promoWidth(index) } key={ index } className='mb-4'>
              <img
                src={ promo.image_url }
                width='100%'
                alt={ promo.alt_text }
                loading='lazy'
              />
              <h4>{ promo.header_text }</h4>
              <h5>{ promo.caption_text }</h5>
              <RedirectButton
                text={ `Edit ${promo.name}` }
                path={ `sections/${promo.id}` }
                color='primary'
                className="float-right mt-1"
                size='sm'
              />
            </Col>
          ))
        }
      </Row>
    </>
  )
}

CmsHomepageSectionPromos.propTypes    = propTypes
CmsHomepageSectionPromos.defaultProps = defaultProps

export default CmsHomepageSectionPromos
